export enum ApplyBudgetTemplateMode {
  Standard = 'standard',
  Overwrite = 'overwrite',
}
